/**
 * @file コンポーネント：フル動画ページスレッドポップアップカード DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledBody,
    StyledButtonList,
    StyledButtonListButton,
    StyledButtonListItem,
    StyledHeadline,
    StyledHeadlineAnchor,
    StyledHeadlineReplyCount,
    StyledHeadlineText,
    StyledNameSpan,
    StyledPostTime,
    StyledReply,
    StyledReplyCount,
    StyledReplyIcon,
    StyledReplyText,
    StyledThreadCard,
    StyledThreadInfo,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledThreadCard
            className={props.isEditReply === true && "is-editing"}
        >
            {/* タイトル */}
            {props.headline && (
                <>
                    {props.handleClickHeadline ? (
                        // 一覧ページで表示
                        <StyledHeadlineAnchor
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                props.handleClickHeadline();
                            }}
                        >
                            <StyledHeadline>
                                <StyledHeadlineText>
                                    {props.headline}
                                </StyledHeadlineText>
                                <StyledHeadlineReplyCount>
                                    ({props.replyCount})
                                </StyledHeadlineReplyCount>
                            </StyledHeadline>
                        </StyledHeadlineAnchor>
                    ) : (
                        // 詳細ページで表示
                        <StyledHeadline>{props.headline}</StyledHeadline>
                    )}
                </>
            )}
            {/* タイトル下 投稿情報 */}
            {props.headline && (
                <StyledThreadInfo
                    className={props.currentPage === "list" && "is-list"}
                >
                    <StyledNameSpan>{props.commentUserName}</StyledNameSpan>
                    <StyledPostTime>{props.passedTime}</StyledPostTime>
                </StyledThreadInfo>
            )}
            {/* 本文 */}
            {props.text && (
                <StyledBody
                    dangerouslySetInnerHTML={{ __html: props.text }}
                    ref={props.refBody}
                />
            )}
            {/* 本文下 投稿情報 */}
            {!props.headline && (
                <StyledThreadInfo>
                    <StyledNameSpan>{props.commentUserName}</StyledNameSpan>
                    <StyledPostTime>{props.passedTime}</StyledPostTime>
                </StyledThreadInfo>
            )}
            {/* ボタンリスト */}
            {props.currentPage === "detail" && (
                <StyledButtonList>
                    {props.isOwner === true && (
                        <>
                            {/* 編集、キャンセルボタン */}
                            <StyledButtonListItem>
                                <StyledButtonListButton
                                    onClick={(e) => {
                                        e.preventDefault();
                                        props.handleClickEditButton();
                                    }}
                                >
                                    {
                                        localized[
                                            !props.isEditReply
                                                ? "Label.Edit"
                                                : "Label.Cancel"
                                        ]
                                    }
                                </StyledButtonListButton>
                            </StyledButtonListItem>
                            {/* 削除ボタン */}
                            <StyledButtonListItem>
                                <StyledButtonListButton
                                    onClick={(e) => {
                                        e.preventDefault();
                                        props.handleClickDeleteButton();
                                    }}
                                >
                                    {localized["Label.Delete"]}
                                </StyledButtonListButton>
                            </StyledButtonListItem>
                        </>
                    )}
                    <StyledButtonListItem>
                        {props.headline ? (
                            // 返信数
                            <>
                                <StyledReply>
                                    <StyledReplyIcon>
                                        <i
                                            className="fas fa-reply"
                                            key="icon-reply"
                                        ></i>
                                    </StyledReplyIcon>
                                    <StyledReplyText>
                                        {localized["Label.Reply"]}
                                        <StyledReplyCount>
                                            {props.replyCount}
                                        </StyledReplyCount>
                                    </StyledReplyText>
                                </StyledReply>
                            </>
                        ) : (
                            // 評価ボタン
                            <>
                                <StyledButtonListButton
                                    onClick={(e) => {
                                        e.preventDefault();
                                        props.handleClickRatingsButton();
                                    }}
                                >
                                    <i
                                        className={
                                            props.isRating
                                                ? "far fa-thumbs-up is-rated"
                                                : "far fa-thumbs-up"
                                        }
                                        key="icon-ratings"
                                    ></i>
                                    {" " +
                                        localized[
                                            props.isRating
                                                ? "Label.Rated"
                                                : "Label.Rate"
                                        ] +
                                        " " +
                                        props.ratingCount}
                                </StyledButtonListButton>
                            </>
                        )}
                    </StyledButtonListItem>
                </StyledButtonList>
            )}
        </StyledThreadCard>
    );
};
